const ss_ajax = function (url,id) {
    const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    var ss = null
    this.$.ajax({
        url: "http://106.12.212.251:8094/index.php/api/index/"+url ,
        type: 'POST', // 默认为GET
        dataType: 'json',
        async: false,
        data: {
            timestamp: this.timestamp,
            random: this.numRandom,
            sign: this.mainSign,
            id
        },
        timeout: 5000,
        success: function (result) {
            // console.log(result);
            
            ss = result
            loading.close();
        },
        error: function (xhr, textStatus) {
            console.log('错误')
            console.log(xhr)
            console.log(textStatus)
        }
    })
    return ss
}

export default ss_ajax